import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PetplanTrialApplication } from 'src/app/interfaces/petplan';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PetplanService {
  constructor(
     private http: HttpClient,
  ) {}

  petplanSave() {
    return this.http.post(`${environment.apiUrl}/api/v2/petplan/save`, null);
  }

  submitPetplanTrialApplication(petplanApplication: PetplanTrialApplication): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/api/v2/petplan/register`,
      petplanApplication
    );
  }
}
